import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { db, auth } from "../../backend/firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import SplashScreen from "../../components/UI/atoms/splash/SplashScreen"
import {  signOut,
          onAuthStateChanged } from "firebase/auth"


import PropTypes from 'prop-types';

// Imports MUI Components
import {  Box,
          Stack,
          Grid } from "@mui/material"

// Import Organisms
import Sidebar from "../../components/UI/organisms/sidebar/Sidebar"
import ProfileSettings from "../../components/UI/organisms/settings/ProfileSettings"

// Import Molecules
import Header from "../../components/UI/organisms/header/logged-in/HeaderLoggedIn"

// Import Assets

// Import Atoms

import { redirectIfNotLoggedIn } from "../../components/functions/redirectIfNotLoggedIn";


// Add CSS keyframes for animations
const styles = `
  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
  }
`;

// Inject styles into document head
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};


const Settings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setCurrentUser] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [, setTwoFactorEnabled] = useState(false);
  const [, setTwoFactorMethods] = useState([]); // Array of selected methods: ["email"], ["sms"], ["email", "sms"], or []

  const [, setProfilePictureUrl] =  useState(null);

  const [showCustomAlert, setShowCustomAlert] = useState(false);
  const [alertMessage, ] = useState("");
  const [alertTitle, ] = useState("")
  const [alertImage, ] = useState("");
  const [alertButton, ] = useState("")
  const [alertButtonType, ] = useState("false")
  const [alertLink, ] = useState("")
  const removalHandledRef = useRef(false);

  // Original 2FA settings for comparison
  const [, setOriginalTwoFactorEnabled] = useState(false);
  const [, setOriginalTwoFactorMethods] = useState([]);

  // Success/Error modals
  // const [successModal, setSuccessModal] = useState({ isOpen: false, message: '', verificationMethod: '' });
  // const [errorModal, setErrorModal] = useState({ isOpen: false, message: '' });

  // Function to check if 2FA settings have changed
  // const has2FAChanges = () => {
  //   // Check if enabled status changed
  //   if (twoFactorEnabled !== originalTwoFactorEnabled) {
  //     return true;
  //   }
  //   
  //   // Check if methods changed (only if 2FA is enabled)
  //   if (twoFactorEnabled && originalTwoFactorEnabled) {
  //     const currentMethods = [...twoFactorMethods].sort();
  //     const originalMethods = [...originalTwoFactorMethods].sort();
  //     
  //     if (currentMethods.length !== originalMethods.length) {
  //       return true;
  //     }
  //     
  //     for (let i = 0; i < currentMethods.length; i++) {
  //       if (currentMethods[i] !== originalMethods[i]) {
  //         return true;
  //       }
  //     }
  //   }
  //   
  //   return false;
  // };

  // const [value, setValue] = React.useState(0);

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };


  // Fetch user details from the database
  useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, async (user) => {
    if (user) {
      removalHandledRef.current = false;
      setCurrentUser(user); // <-- store the whole user object
      
      // Email change logic is now handled globally in useAuth hook
      
      loadUserDetails(user.uid); // Fetch user details from the database
    } else {
      removalHandledRef.current = false;
      setCurrentUser(null);
      setUserDetails(null);
    }
  });

    return () => unsubscribe();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadUserDetails = async (uid) => {
        const userRef = doc(db, "users", uid);
  try {
    const snapshot = await getDoc(userRef);
    if (snapshot.exists()) {
      removalHandledRef.current = false;
      const userData = snapshot.data();
      setUserDetails(userData);
      setProfilePictureUrl(userData.profilePictureUrl || null);
      
            // Load 2FA settings if they exist - ensure proper state sync
            
            if (userData.twoFactorEnabled !== undefined) {
              setTwoFactorEnabled(userData.twoFactorEnabled);
              setOriginalTwoFactorEnabled(userData.twoFactorEnabled); // Store original value
            } else {
              setTwoFactorEnabled(false); // Default to false if not set
              setOriginalTwoFactorEnabled(false); // Store original value
            }
            
            if (userData.twoFactorMethod) {
              // Handle both single method and comma-separated multiple methods
              if (userData.twoFactorMethod.includes(',')) {
                const methods = userData.twoFactorMethod.split(',').filter(m => m.trim());
                setTwoFactorMethods(methods);
                setOriginalTwoFactorMethods([...methods]); // Store original value
              } else {
                setTwoFactorMethods([userData.twoFactorMethod]);
                setOriginalTwoFactorMethods([userData.twoFactorMethod]); // Store original value
              }
            } else {
              setTwoFactorMethods([]); // No methods selected by default
              setOriginalTwoFactorMethods([]); // Store original value
            }
    } else {
      // User document not found - user was removed, sign out and redirect
      try {
        if (!removalHandledRef.current) {
          removalHandledRef.current = true;
          if (auth.currentUser) {
            await signOut(auth);
          }
        }
      } catch (error) {
        if (error?.code !== "auth/no-current-user") {
          console.error('Error signing out removed user:', error);
        }
      }
      navigate('/sign-in', {
        state: {
          from: location.pathname,
          message: 'Your session has ended. Please sign in again.'
        },
        replace: true
      });
    }
  } catch (error) {
    if (error?.code === "permission-denied") {
      if (!removalHandledRef.current) {
        removalHandledRef.current = true;
        try {
          if (auth.currentUser) {
            await signOut(auth);
          }
        } catch (signOutError) {
          if (signOutError?.code !== "auth/no-current-user") {
            console.error('Error signing out removed user:', signOutError);
          }
        }
        navigate('/sign-in', {
          state: {
            from: location.pathname,
            message: 'Your session has ended. Please sign in again.'
          },
          replace: true
        });
      }
    } else {
      console.error("Error fetching user details:", error?.message || error);
    }
  }
};

   // Handle logout
    // const handleLogout = () => {
    //   signOut(auth).then(() => {
    //     navigate("/", { replace: true });
    //   });
    // };

    // Handle input changes
  // const handleInputChange = (field, value) => {
  //   setEditedDetails((prevDetails) => ({
  //     ...prevDetails,
  //     [field]: value,
  //   }));
  // };
  // Handle save changes
// const handleSave = async () => {
//   if (user) {
//     try {
//       const userRef = doc(db, "users", user.uid);
//       
//       // Check if email or mobile were changed
//       const emailChanged = editedDetails.email && editedDetails.email !== userDetails.email;
//       const mobileChanged = editedDetails.contactNumber && editedDetails.contactNumber !== userDetails.contactNumber;
//       
//       // Handle email update with authEmail sync
//       if (emailChanged) {
//         const newEmail = editedDetails.email;
//         
//         // Update Firebase Auth email
//         await updateEmail(user, newEmail);
//         await sendEmailVerification(user);
//         
//         // Update Firestore with new email and reset emailVerified
//         await updateDoc(userRef, {
//           email: newEmail,
//           authEmail: newEmail,
//           emailVerified: "No",
//           emailChangeStatus: "pending",
//           emailChangeTimestamp: Date.now()
//         });
//         
//         // Show success message
//         setShowSuccessMessage(true);
//         setTimeout(() => {
//           setShowSuccessMessage(false);
//         }, 3000);
//         
//         // Update local state
//         setUserDetails(prev => ({
//           ...prev,
//           email: newEmail,
//           authEmail: newEmail,
//           emailVerified: "No"
//         }));
//       }
//       
//       // Handle mobile update (update only in Firestore, not Firebase Auth)
//       if (mobileChanged) {
//         await updateDoc(userRef, {
//           contactNumber: editedDetails.contactNumber,
//           mobile: editedDetails.contactNumber
//         });
//         
//         setUserDetails(prev => ({
//           ...prev,
//           contactNumber: editedDetails.contactNumber,
//           mobile: editedDetails.contactNumber
//         }));
//       }
//       
//       // Handle other field updates (excluding email and mobile)
//       const otherFields = { ...editedDetails };
//       if (emailChanged) {
//         delete otherFields.email;
//       }
//       if (mobileChanged) {
//         delete otherFields.contactNumber;
//         delete otherFields.mobile;
//       }
//       
//       // Update other fields
//       if (Object.keys(otherFields).length > 0) {
//         await updateDoc(userRef, otherFields);
//         setUserDetails(prev => ({ ...prev, ...otherFields }));
//       }
//       
//       setIsEditing(false);
//       
//       if (!emailChanged && !mobileChanged) {
//         setShowSuccessMessage(true);
//         setTimeout(() => {
//           setShowSuccessMessage(false);
//         }, 3000);
//       }
//       
//     } catch (error) {
//       console.error("Error updating profile:", error);
//       setErrorModal({ isOpen: true, message: error.message || "Failed to update profile. Please try again." });
//     }
//   }
// };

  // Handle profile picture upload

// Handle drag and drop
// const handleDragOver = (e) => {
//   e.preventDefault();
// };

// const handleDrop = (e) => {
//   e.preventDefault();
//   const file = e.dataTransfer.files[0];
//   if (file) {
//     const fakeEvent = { target: { files: [file] } };
//     handleImageUpload(fakeEvent);
//   }
// };

// Handle image deletion
// const handleImageDelete = async () => {
//   if (!profilePictureUrl || profilePictureUrl === "https://via.placeholder.com/50") return;

//   setDeleteModalConfig({ isOpen: true });
// };

// Confirm image deletion
// const handleConfirmDelete = async () => {
//   try {
//     // Delete from storage
//     const imageRef = ref(storage, profilePictureUrl);
//     await deleteObject(imageRef);

//     // Update user profile in Firestore
//     const userRef = doc(db, "users", user.uid);
//     await updateDoc(userRef, {
//       profilePictureUrl: null
//     });

//     // Update local state
//     setProfilePictureUrl(null);
//     setUserDetails(prev => ({ ...prev, profilePictureUrl: null }));
    
//     // Reset the file input to allow re-uploading after deletion
//     const fileInput = document.getElementById('profile-image-upload');
//     if (fileInput) {
//       fileInput.value = '';
//     }
    
//     // Close modal
//     setDeleteModalConfig({ isOpen: false });
//   } catch (error) {
//     console.error("Error deleting image:", error);
//     setUploadError("Failed to delete image. Please try again.");
//     setDeleteModalConfig({ isOpen: false });
//   }
// };

// Close delete confirmation modal
// const closeDeleteModal = () => {
//   setDeleteModalConfig({ isOpen: false });
// };

  const boxStylesContent = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#FDF9F3",
    // width: "100%"
  }

  // const styleTabsContainer = {
  //   justifyContent: "start",
  //   alignItems: "center",
  //   padding: "0 0 20px 0",
  //   margin: "0 30px",
  //   width: "calc(100% - 60px)",
  //   borderBottom: "1px solid rgba(89, 84, 74, .2)",
  // }

  // const typographyStylesH2 = {
  //   color: "#C5A572",
  // }

  // UseEffects
  useEffect(() => {
    // const details = fetchUserDetails(setUserDetails);
    const redirect = redirectIfNotLoggedIn(setShowCustomAlert, navigate);
    
    // Force refresh user data when component mounts to sync any auth changes
    if (user) {
      loadUserDetails(user.uid);
    }
    
    // const notify = notifyFirstUser();
    return () => {
      // details && details();
      redirect && redirect();
      // notify && notify();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // Force refresh user data when user changes (e.g., after sign-in with new email)
  useEffect(() => {
    if (user && user.uid) {
      // Add a small delay to ensure Firebase Auth is fully loaded
      const timeoutId = setTimeout(() => {
        loadUserDetails(user.uid);
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.uid, user?.email]);

  return (
    <div>
      {/* All Content */}
      <Box 
        sx={boxStylesContent}>
        {/* Sidebar */}
        <Box
          display={{
            xs: "none",
            sm: "none",
            md: "block",
            lg: "block",
            xl: "block",
          }}>
        <Sidebar
          fName={userDetails?.firstName}
          lName={userDetails?.lastName}
          email={userDetails?.email}
        />
        </Box>

          {/*Grids */}
          <Grid
            container
            // rowSpacing={2}
            // columnSpacing={2}
            sx={{
              width: "100%",
              height: "100vh",
              // backgroundColor: "blue",
              "& .MuiGrid-item": {
                display: "flex",
                justifyContent: "center",
                // backgroundColor: "blue",
              },
            }}>

            {/* Main Content */}
            <Grid 
              size={{ 
                xs: 12, 
                sm: 12, 
                md: 12, 
                lg: 12, 
                xl: 12 
              }} 
              item
            >

              {/* Main Content */}
              <Box
                sx={{
                  width: "100%",
                  backgroundColor: "#FDF9F3",
                  height: "100%",
                }}>

                <Stack
                  direction="column"
                  spacing={2}>

                  <Header
                    page="Settings"
                    count={1}/>

                  <ProfileSettings/>

                </Stack>

              </Box>

            </Grid>

          </Grid>  

      </Box>

      <SplashScreen
        message={alertMessage}
        title={alertTitle}
        isOpen={showCustomAlert}
        image={alertImage}
        button={alertButton}
        buttonType={alertButtonType}
        destination={alertLink}
        onClose={() => setShowCustomAlert(false)}/>

          
    </div>
  );
};

export default Settings;